
function initMap() {
    var script = document.createElement('script');
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", "https://maps.google.com/maps/api/js?key=" + $('#map').data('googleapikey') + "&callback=loadMap");
    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script);
}

var map;
var marker;

function loadMap() {

    var locations = $('#map').data('locations');
    var pos = {
        lat: parseFloat(locations[0]['latitude']),
        lng: parseFloat(locations[0]['longitude'])
    }
    
    var bounds = new google.maps.LatLngBounds();

    map = new google.maps.Map(document.getElementById("map"), {
        zoom: 15,
        center: pos,
        gestureHandling: "cooperative",
        streetViewControl: false,
        zoomControl: true,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL,
        },
        mapTypeControl: true,
        mapTypeControlOptions: {
            'style': google.maps.MapTypeControlStyle.DEFAULT,
            'position': google.maps.ControlPosition.LEFT_BOTTOM,
        }
    });

    for (var i = 0; i < locations.length; ++i) {

        marker = new google.maps.Marker({
            position: {
                lat: parseFloat(locations[i]['latitude']), 
                lng: parseFloat(locations[i]['longitude'])
            },
            map: map,
            title: locations[i]['title']
        });

        bounds.extend(marker.position);
    }
    
    if(locations.length > 1) {
        map.fitBounds(bounds);
    }
    
}

$(document).ready(function(){
    initMap();
});